import { ASSETS, MATERIALS } from "@/data/site";
import { Reveal, SectionHeading } from "@/components/Reveal";

const CLOSEUPS = [
  { src: ASSETS.horseFramed, alt: "Framed Ashva horse relief in white marble" },
  { src: ASSETS.elephantFramed, alt: "Framed Gajraj elephant relief in white marble" },
  { src: ASSETS.balajiPanel, alt: "Tirupati Balaji framed relief in white marble" },
  { src: ASSETS.krishnaFramed, alt: "Framed Murlidhar Krishna relief with flute and cow" },
];

export default function Story() {
  return (
    <section data-testid="stone-as-art-section" className="noise-overlay bg-obsidian py-24 sm:py-32">
      <div className="mx-auto max-w-7xl px-6 sm:px-12 lg:px-20">
        <SectionHeading
          light
          eyebrow="Stone as Art"
          title="We Don't Just Shape Stone. We Tell Stories Through It."
          script="Art in Every Form"
          description="Every surface carries a possibility. Every carving carries a story. At ShilpStones Creations, stone becomes a medium for culture, architecture, emotion and design."
        />

        <div className="mt-16 grid grid-cols-2 gap-5 lg:grid-cols-4">
          {CLOSEUPS.map((c, i) => (
            <Reveal key={c.alt} delay={i * 0.12}>
              <div className={`group spotlight-frame overflow-hidden rounded-xl ${i % 2 === 1 ? "lg:mt-12" : ""}`}>
                <img
                  src={c.src}
                  alt={c.alt}
                  loading="lazy"
                  className="aspect-[3/4] w-full object-cover transition-transform duration-[1200ms] ease-out group-hover:scale-105"
                />
              </div>
            </Reveal>
          ))}
        </div>

        <div className="mt-28">
          <SectionHeading
            light
            align="left"
            eyebrow="Material & Craft"
            title="Every Stone Has a Character. We Bring It Forward."
            description="Marble, sandstone, onyx and quartz — selected for vein, tone and texture, then finished by hand and machine."
          />
          <div className="mt-12 grid gap-5 sm:grid-cols-2 lg:grid-cols-4">
            {MATERIALS.map((m, i) => (
              <Reveal key={m.name} delay={i * 0.1}>
                <div data-testid={`material-card-${i}`} className="group relative overflow-hidden rounded-xl spotlight-frame">
                  <img
                    src={m.image}
                    alt={m.name}
                    loading="lazy"
                    className="aspect-square w-full object-cover transition-transform duration-[1200ms] group-hover:scale-105"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-obsidian/85 to-transparent" />
                  <div className="absolute inset-x-0 bottom-0 p-5">
                    <p className="font-serif text-lg text-stone-100">{m.name}</p>
                    <p className="mt-0.5 text-[11px] uppercase tracking-[0.2em] text-gold-soft">{m.note}</p>
                  </div>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
